import * as Yup from 'yup';

export const menuConfigurationSchema = Yup.object().shape({
  menuSettingMethod: Yup.string()
    .oneOf(['pos', 'web', 'file', 'manual'], 'Invalid method selected')
    .required('Method is required'),
  posName: Yup.string().when(
    'menuSettingMethod',
    ([menuSettingMethod], schema) =>
      menuSettingMethod === 'pos'
        ? schema.required('POS System is required')
        : schema.notRequired()
  ),
  businessId: Yup.string().when(
    ['menuSettingMethod', 'posName'],
    ([menuSettingMethod, posName], schema) =>
      menuSettingMethod === 'pos' && posName === 'Urban Piper'
        ? schema.required('Business ID is required')
        : schema.notRequired()
  ),
  tmbillposId: Yup.string().when(
    ['menuSettingMethod', 'posName'],
    ([menuSettingMethod, posName], schema) =>
      menuSettingMethod === 'pos' && posName === 'tmbill'
        ? schema.required('TM POS ID is required')
        : schema.notRequired()
  ),
  menuSettingDetails: Yup.object().test(
    'at-least-one-store-configured',
    'At least one store must be configured',
    function (value) {
      const { menuSettingMethod, posName } = this.parent;

      if (menuSettingMethod !== 'pos') return true;

      if (posName === 'Urban Piper') {
        return Object.values(value || {}).some((store: any) => store.refId);
      }

      if (posName === 'tmbill') {
        return Object.values(value || {}).some(
          (store: any) => store.tmBillBrandShortName
        );
      }

      return true;
    }
  ),
  websiteUrl: Yup.string().when(
    'menuSettingMethod',
    ([menuSettingMethod], schema) =>
      menuSettingMethod === 'web'
        ? schema.required('Website URL is required').url('Invalid URL format')
        : schema.notRequired()
  ),
});
